import { createContext, useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { getPatientNutrients } from '../api/getPatientNutrients';

// Define default context value
const defaultContextValue = {
  state: {
    allNutrientsData: null,
    allNutrientsLoading: true,
  },
};

export const NutrientsContext = createContext(defaultContextValue);

export const NutrientsContextProvider = ({ children, workflowToken }) => {
  // Fetch all nutrients data once
  const { data: rawData, isLoading: allNutrientsLoading } = useQuery(
    `nutrients_all_${workflowToken}`,
    () => getPatientNutrients(workflowToken),
    {
      enabled: !!workflowToken,
      refetchOnWindowFocus: false,
      staleTime: 3600,
    },
  );

  // Memoize the context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      state: {
        allNutrientsData: rawData,
        allNutrientsLoading,
      },
    }),
    [rawData, allNutrientsLoading],
  );

  return <NutrientsContext.Provider value={contextValue}>{children}</NutrientsContext.Provider>;
};

// Custom hook to use the nutrients context
export const useNutrientsContext = () => {
  const context = useContext(NutrientsContext);
  if (!context) {
    return defaultContextValue;
  }
  return context;
};
